import React, { Fragment } from "react";
import cx from "classnames";
import { connect } from "react-redux";
import _ from "lodash";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import { withRouter } from "react-router-dom";
import HeaderLogo from "../AppLogo";

import { setEnableSearchBarOnHeader } from "../../reducers/ThemeOptions";
import SearchBox from "./Components/SearchBox";
import UserBox from "./Components/UserBox/UserBox";
import detect_mobile from "../../utils/detect_mobile";
import service from "../../utils/service"; 

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFullscreen: false,
      authConfig: null, 
    };
  }

  componentDidMount() {
    this.fetchAuthConfig();
  }

  fetchAuthConfig = async () => {
    try {
      const res = await service.get("v4/configs/auth");
      this.setState({ authConfig: res?.data?.auth });
    } catch (err) {
      console.error("Auth config load failed", err);
    }
  };

  handleCognitoLogin = () => {
    const cognito = this.state.authConfig?.cognito;

    if (!cognito?.enabled) return;

    const redirectUri = `${window.location.origin}/users/auth/cognito_idp/callback`;

    const url =
      `${cognito.user_pool_site}/login` +
      `?client_id=${cognito.client_id}` +
      `&response_type=code` +
      `&scope=openid+email+profile` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}`;

    window.location.href = url; // 🚀 direct redirect
  };

  toggleFullscreen = () => {
    const elem = document.documentElement;

    if (!this.state.isFullscreen) {
      if (elem.requestFullscreen) elem.requestFullscreen();
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();

      this.setState({ isFullscreen: true });
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();

      this.setState({ isFullscreen: false });
    }
  };

  render() {
    const {
      headerBackgroundColor,
      enableHeaderShadow,
      openInput,
      page_config,
    } = this.props;

    const { isFullscreen } = this.state;

    const show_search_bar = _.get(page_config, "header.show_search_bar", false);

    const token = localStorage.getItem("CW_JWT_TOKEN");
    const isLoggedIn = !!token;

    return (
      <Fragment>
        <CSSTransitionGroup
          component="div"
          className={cx(
            "app-header",
            headerBackgroundColor,
            { "header-shadow": enableHeaderShadow },
            `${detect_mobile() ? "bg-lightBlue" : ""}`
          )}
          transitionName="HeaderAnimation"
          transitionAppear={true}
          transitionAppearTimeout={1500}
          transitionEnter={false}
          transitionLeave={false}
        >
          {!openInput && <HeaderLogo />}

          <div className="d-flex justify-content-end w-100 align-items-center">
            {isLoggedIn ? (
              <>
                <div className="flex-grow-1 mx-3">
                  {show_search_bar && <SearchBox />}
                </div>

                <i
                  className={`fa-solid ${
                    isFullscreen ? "fa-compress" : "fa-expand"
                  } text-primary m-2 fs-24 d-none d-md-block cursor-pointer`}
                  onClick={this.toggleFullscreen}
                ></i>

                <UserBox />
              </>
            ) : (
              <button
                className="btn btn-primary"
                onClick={this.handleCognitoLogin} // ✅ direct call
              >
                Sign In
              </button>
            )}
          </div>
        </CSSTransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  page_config: _.get(state, "my_profile.page_config", {}),
});

export default connect(mapStateToProps)(
  withRouter(Header)
);